import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AgTechApplication } from '../app/AgTechApplication';
import { AgTechDataContext, DataContext } from '../data/common/AgTechDataContext'
import React from 'react'
import { Provider } from 'react-redux';

const queryClient = new QueryClient();

const AgTechAppDataContext = (props: { app: AgTechApplication, children: React.ReactNode }) => {
    let webAppDataContext: AgTechDataContext = {
        baseURL: props.app.data.baseURL
    };

    return (
        <DataContext.Provider value={webAppDataContext}>
            <QueryClientProvider client={queryClient}>
                <Provider store={props.app.data.dataStore}>
                    {props.children}
                </Provider>
            </QueryClientProvider>
        </DataContext.Provider>
    )
}

export default AgTechAppDataContext